import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_RouterLink = _resolveComponent("RouterLink")!

  return (_openBlock(), _createElementBlock("span", {
    class: _normalizeClass({
            'user-tag':true,
            'is_full':_ctx.full==1,
        })
  }, [
    _createVNode(_component_RouterLink, {
      to: {
                path:'/user/profile/'+_ctx.user._id,
            }
    }, {
      default: _withCtx(() => [
        _createTextVNode(_toDisplayString(_ctx.user.name), 1)
      ]),
      _: 1
    }, 8, ["to"])
  ], 2))
}